import { getProfissionalLabels } from "./profissionalRotulo";
import { obterEstabelecimentoAtivoId } from "./estabelecimentoContext";

const CACHE_PREFIX = "fz:rotulo_profissional:";
export const ROTULO_PROFISSIONAL_CHANGED = "fz:rotulo-profissional:changed";

export const lerRotuloProfissionalCache = (estabelecimentoId) => {
  if (!estabelecimentoId) return null;
  try {
    const raw = localStorage.getItem(`${CACHE_PREFIX}${estabelecimentoId}`);
    if (raw === null) return null;
    return raw;
  } catch {
    return null;
  }
};

export const gravarRotuloProfissionalCache = (
  estabelecimentoId,
  rotulo,
  { silent = false } = {}
) => {
  if (!estabelecimentoId) return;
  const valor =
    rotulo === null || rotulo === undefined ? "" : String(rotulo).trim();

  try {
    localStorage.setItem(`${CACHE_PREFIX}${estabelecimentoId}`, valor);
  } catch {
    // noop
  }

  if (!silent) {
    window.dispatchEvent(
      new CustomEvent(ROTULO_PROFISSIONAL_CHANGED, {
        detail: {
          estabelecimentoId: Number(estabelecimentoId),
          rotulo: valor || null,
        },
      })
    );
  }
};

/** Labels a partir do cache do estabelecimento ativo (síncrono). */
export const getProfissionalLabelsFromCache = (estabelecimentoId) => {
  const id = estabelecimentoId ?? obterEstabelecimentoAtivoId();
  const cached = lerRotuloProfissionalCache(id);
  if (cached === null) return null;
  return getProfissionalLabels({
    rotulo_profissional: cached || null,
  });
};
